import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";

export const FETCH_USER_GROUPS = "fetchUserGroups";
export const USER_GROUP_COLLECTION = "userGroupCollection";

const state = {
    errors: null,
    collection: [],
};

const getters = {
    [USER_GROUP_COLLECTION](state) {
        return state.collection;
    }
};

const actions = {
    [FETCH_USER_GROUPS](context) {
        let appLocale = i18nService.getActiveLanguage()
        ApiService.get("userGroup")
            .then(({ data }) => {
                // create localized fields
                let dataLocalized = data.map((item) => {
                    if (item.translations.length == 0) {
                        item.groupName = "Name not defined"
                        return item
                    }

                    if (item.translations[appLocale]) {
                        item.groupName = item.translations[appLocale].name
                    } else {
                        item.groupName = item.translations[Object.keys(item.translations)[0]].name;
                    }

                    return item
                })


                context.commit(FETCH_USER_GROUPS, dataLocalized);
            })
            .catch((error) => {
                console.log('Error!: ', error);
            });
    },

    createUserGroup(state, payload) {
        state.commit('createUserGroup', payload);
    },

}

const mutations = {
    [FETCH_USER_GROUPS](state, data) {
        // state.collection = data.map((item) => {
        //     let translations = item.translations;
        //     if (translations.length == 0) {
        //         item.name = "Name not defined";
        //     }
        //     item.name = translations["en"].name;
        //     return item;
        // });
        state.collection = data;
    },

    createUserGroup(state, data) {
        state.collection.push(data)
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
